import { render, staticRenderFns } from "./NerisCurrentEntity.vue?vue&type=template&id=34f0c8ae&"
import script from "./NerisCurrentEntity.vue?vue&type=script&lang=js&"
export * from "./NerisCurrentEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports